import { CustomerManagementUserContactEnum } from "_constants";
import { useCustomerManagementStore } from "_hooks";
import AppModal from "_lib/AppModal";
import AppVerifyCode from "_lib/AppVerifyCode";
import { FormPhoneNumber } from "_lib/Form";
import { useEffect, useMemo, useState } from "react";
import { useCallback } from "react";
import PropTypes from "prop-types";
import { IoLogoWhatsapp } from "react-icons/io";
import { Flex } from "antd";

const ProfileAddSecondaryNumberModal = (props) => {
  const { toggle, open } = props;

  const {
    customerManagement: { submitContactStatus },
    submitContact,
    fetchUser,
    clearSubmitContactStatus,
  } = useCustomerManagementStore();

  const [step, setStep] = useState(0);
  const [verifyCodePayload, setVerifyCodePayload] = useState(null);

  const onClose = useCallback(() => {
    setStep(0);
    toggle();
  }, [toggle]);

  useEffect(() => {
    if (submitContactStatus === "success") {
      clearSubmitContactStatus();
      fetchUser();
      onClose();
    }
  }, [clearSubmitContactStatus, fetchUser, onClose, submitContactStatus]);

  const onVerify = useCallback(
    (values) => {
      submitContact({
        contact: values?.phoneNumber,
        isPrimary: false,
        otpCode: values?.verificationCode,
        type: CustomerManagementUserContactEnum.PHONE,
      });
    },
    [submitContact]
  );

  const onSuccessCallback = useCallback((values) => {
    setVerifyCodePayload({
      phoneNumber: `${values.prefix}${values.phoneNumber}`,
    });
    setStep(1);
  }, []);

  const { title, subtitle } = useMemo(() => {
    let title = "Add Secondary Number";
    let subtitle = "Enter your phone number below";
    if (step === 1) {
      title = "Enter your phone code";
      subtitle = (
        <Flex align="center">
          We’ve sent a code to {verifyCodePayload?.phoneNumber} (
          <IoLogoWhatsapp size={18} color="green" /> WhatsApp)
        </Flex>
      );
    }
    return { title, subtitle };
  }, [step, verifyCodePayload?.phoneNumber]);

  const loading = submitContactStatus === "loading";

  return (
    <AppModal
      open={open}
      title={title}
      subtitle={subtitle}
      onClose={onClose}
      width={400}
    >
      {step === 0 && <FormPhoneNumber onSuccessCallback={onSuccessCallback} />}
      {step === 1 && (
        <AppVerifyCode
          payload={verifyCodePayload}
          loading={loading}
          onVerify={onVerify}
        />
      )}
    </AppModal>
  );
};

ProfileAddSecondaryNumberModal.propTypes = {
  open: PropTypes.bool,
  toggle: PropTypes.func,
};

export default ProfileAddSecondaryNumberModal;
